import { selectCanvasZoom } from '@store/slices/uiSlice';
import { store } from '@store/store';

/**
 * Reads the persisted canvas zoom once, for callers outside render that must
 * not subscribe to it — the initial viewport of a canvas being mounted.
 *
 * Lives outside `uiSlice` on purpose: `store.ts` imports every slice, so a slice
 * that imports the store value back forms a runtime cycle. Nothing in the
 * store's own module graph imports this file.
 */
export const getCanvasZoom = () => selectCanvasZoom(store.getState());
